<template>
  <div class="content">
    <div class="button-group">
      <button @click="goToRoles" class="btn btn-sm btn-info">Roles</button>
      <button @click="goToModificarUsuario" class="btn btn-sm btn-primary">
        Modificar
      </button>
      <button @click="eliminarUsuario" class="btn btn-sm btn-danger">
        Eliminar
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "UsuariosTablaActions",
  methods: {
    goToRoles() {
      this.$router.push(`/admin/users/${this.params.data.id_usuario}/roles`);
    },
    goToModificarUsuario() {
      this.$router.push(`/admin/users/${this.params.data.id_usuario}`);
    },
    eliminarUsuario() {
      this.$store.commit("usuarios/setEliminarUsuario", this.params.data);
      this.$bvModal.show("deleteUser");
    },
  },
});
</script>

<style scoped></style>
